export default __webpack_public_path__ + "static/media/uniswapWalletBannerDark.73333210.png";